import { Box, Button, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";
import { AccessKeyCreateResponse } from "../../../api/models/access-key-model";

interface DeleteAccessKeyModalProps {
  showDeleteAccessKeyModal: boolean;
  setShowDeleteAccessKeyModal: (showDeleteAccessKeyModal: boolean) => void;
  deleteFunction: () => void;
  selectedAccessKey: AccessKeyCreateResponse | null;
  setSelectedAccessKey?: (accessKey: AccessKeyCreateResponse | null) => void;
}

const DeleteAccessKeyModal = ({
  showDeleteAccessKeyModal,
  setShowDeleteAccessKeyModal,
  deleteFunction,
  selectedAccessKey,
  setSelectedAccessKey,
}: DeleteAccessKeyModalProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <Modal
      open={showDeleteAccessKeyModal}
      onClose={() => setShowDeleteAccessKeyModal(false)}
    >
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 350,
            minWidth: 350,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 30,
            paddingLeft: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center" }}>
            {labels.delete_access_key}?
          </p>
          <p className="mt-10 red-color" style={{ textAlign: "center" }}>
            {labels.undone_action}
          </p>
          <div className="w-100 flex gap-4 mt-10">
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setShowDeleteAccessKeyModal(false);
              }}
            >
              {labels.cancel}
            </Button>
            <Button variant="contained" fullWidth onClick={deleteFunction}>
              {labels.accept}
            </Button>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default DeleteAccessKeyModal;
